import useTranslation from "../../common/translations";
import { useOfferFiltersState } from "../context/OfferFiltersContext";
import { useOfferFilterSubmit } from "../hooks/useOfferFilterSubmit";
import { toStringArray } from "../utils/buildQueryString";
import { isFilterVisible } from "../utils/isFilterVisible";
import ChevronDownIcon from "./ChevronDownIcon";
import DesktopFilterPopover from "./DesktopFilterPopover";
import FilterBadge from "./FilterBadge";
import FilterContent from "./FilterContent";
import clsx from "clsx";
import React from "react";
export default function DesktopFilterPill({ filter, }) {
    const { t } = useTranslation("offer-filters");
    const { committedState, facetData } = useOfferFiltersState();
    const submitFilters = useOfferFilterSubmit();
    const facet = filter.facet_group != null ? facetData[filter.facet_group] : undefined;
    if (!isFilterVisible(filter, facet))
        return null;
    const selectedValues = filter.facet_group != null ? toStringArray(committedState[filter.id]) : [];
    const count = selectedValues.filter((v) => v).length;
    const isActive = count > 0;
    return (<DesktopFilterPopover placement="bottom-start" onSubmit={() => submitFilters()} trigger={({ ref, open, toggle }) => (<button ref={ref} type="button" onClick={toggle} className={clsx("flex items-center gap-1.5 h-10 px-3.5 rounded-full border text-sm font-medium whitespace-nowrap transition-colors", isActive
                ? "bg-[#ECF5FE] border-[#0071CE] text-[#1C2022]"
                : "bg-white border-[#A1A2A5] text-[#1C2022]")}>
          <span>{filter.label}</span>
          {isActive ? <FilterBadge count={count}/> : null}
          <ChevronDownIcon className={clsx("size-4 shrink-0 transition-transform", open && "rotate-180")}/>
        </button>)}>
      {facet ? <FilterContent filter={filter} facet={facet}/> : null}
    </DesktopFilterPopover>);
}
